import {GET, POST} from "@/services/gateway";

const getBackedupItems = () => {
  return GET('dashboard/box/backup-events');
}

const list = (data) => {
  return POST('dashboard/box/backup-events', data);
}

const getBackupItems = () => {
  return GET('dashboard/box/backup-items');
}

export {
  getBackedupItems,
  list,
  getBackupItems,
}
